
import React from 'react';
import {
  Table,
  TableHeader,
  TableRow,
  TableHead,
  TableBody,
} from "@/components/ui/table";
import { Job } from './types';
import { JobTableRow } from './JobTableRow';

interface JobTableViewProps {
  jobs: Job[];
}

export const JobTableView: React.FC<JobTableViewProps> = ({ jobs }) => {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Title</TableHead>
          <TableHead>Company / Client</TableHead>
          <TableHead>Location</TableHead>
          <TableHead>Status</TableHead>
          <TableHead>Type</TableHead>
          <TableHead>Posted</TableHead>
          <TableHead>Applicants</TableHead>
          <TableHead>Actions</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {jobs.map((job) => (
          <JobTableRow key={job.id} job={job} />
        ))}
      </TableBody>
    </Table>
  );
};
